export enum Breakpoint {
    XSmall,   // < 375
    Small,    // < 600
    Medium,   // < 601 - 959 (Mobile Header)
    Large,    // 960 - 1439 (Desktop Header)
    XLarge    // > 1440
}






